import React, { useState } from "react";
import { Constants } from "../../CommonMethhods/Constants";

function DividendTable(props) {
  const data = props.data;
  const seg = props.seg;

  const showDividendData = (data) => {
    return (
      data &&
      data.map((item, key) => {
        return (
          <tr key={key}>
            <td>
              {item.Clientcode === "" || undefined || null
                ? "-"
                : item.Clientcode}
            </td>
            <td>
              {item.scripName === "" || undefined || null
                ? "-"
                : item.scripName}
            </td>
            <td>{item.isin === "" || undefined || null ? "-" : item.isin}</td>
            <td>{item.date === "" || undefined || null ? "-" : item.date}</td>
            <td>{item.Type === "" || undefined || null ? "-" : item.Type}</td>
            <td>
              {item.divPerShare === "" || undefined || null
                ? "-"
                : item.divPerShare}
            </td>
            <td>{item.qty === "" || undefined || null ? "-" : item.qty}</td>
            <td>
              {item.divAmount === "" || undefined || null
                ? "-"
                : item.divAmount}
            </td>
          </tr>
        );
      })
    );
  };

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper">
        {data && data.length > 0 ? (
          <table className="table">
            <thead>
              <tr>
                {/* {Object.keys(data[0]).map((value, index) => {
                    return (
                      <th key={index} className="snapshot-table-column">
                        {value}
                      </th>
                    );
                  })} */}
                <th scope="col">Client Code</th>
                <th scope="col">Scrip Name</th>
                <th scope="col">ISIN</th>
                <th scope="col" className="text-center">
                  Date
                </th>
                <th scope="col" className="text-center">
                  Type
                </th>
                <th scope="col" className="text-center">
                  Div. Per Share
                </th>
                <th scope="col" className="text-center">
                  QTY
                </th>
                <th scope="col" className="text-center">
                  Div. Amount
                </th>
              </tr>
            </thead>
            <tbody>{showDividendData(data)}</tbody>
          </table>
        ) : (
          <div className="report-error-message">
            {Constants.Dividend_Report_doesnt_exist}
          </div>
        )}
      </div>
    </>
  );
}
export default DividendTable;
